import { Route } from 'react-router-dom';
import Layout from '../components/layout';
import MediaGallery from '../Pages/Media/MediaGallery';
import ProtectedRoute from '../components/ProtectedRoute';

export const MediaRoutes = ({ menuActive, setMenuActive }) => (
    <>
        <Route path="/media" element={
            <ProtectedRoute>
                <Layout activePage='media' menuActive={menuActive} setMenuActive={setMenuActive}>
                    <MediaGallery />
                </Layout>
            </ProtectedRoute>
        }
        />
    </>
);